export const CARD_LIST_ATTEMPT = "CARD_LIST_ATTEMPT";
export const CARD_LIST_SUCCESS = "CARD_LIST_SUCCESS";
export const CARD_LIST_FAILED = "CARD_LIST_FAILED";
export const LOGOUT = "LOGOUT";